var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "calendar_svg__a",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "calendar_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#calendar_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M5.5 8.5h21v18h-21z",
    mask: "url(#calendar_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 6h1v5h-1z",
    mask: "url(#calendar_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16 3h1v21h-1z",
    mask: "url(#calendar_svg__b)",
    transform: "rotate(90 16.5 13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.5 13.5h1v12h-1z",
    mask: "url(#calendar_svg__b)",
    transform: "rotate(90 16 19.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21 6h1v5h-1z",
    mask: "url(#calendar_svg__b)"
  }))));
};
export default SvgCalendar;